// extracted by mini-css-extract-plugin
export default {"root":"LoaderWrapper_root__7i7zs","loader":"LoaderWrapper_loader__+HUZA"};